<template>
  <section>
    <Title v-if="title.CashPickUp" :title-name="title.CashPickUp.titleName" :title-link="title.CashPickUp.titleLink" />
    <div v-if="lang && lang.monetary_compensation" id="monetatry-compensation-block">
      <div class="container pt-4">
        <div class="compensation-status">
          <div v-if="passengerName" class="mb-5">
            <span v-html="replaceStr(lang.monetary_compensation.THANK, ['<passenger_name>'], [passengerName])"></span>
          </div>
          <div class="content-status">
            <div class="row mb-1">
              <div class="col-5">{{ lang.monetary_compensation.STATUS }}</div>
              <div class="col-7">
                <span v-if="monetaryOrder.status == 0">NEW</span>
                <span v-if="monetaryOrder.status == 1">OPEN</span>
                <span v-if="monetaryOrder.status == 2">PENDING</span>
                <span v-if="monetaryOrder.status == 3">CLOSE</span>
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5">{{ lang.monetary_compensation.ISSUE_DATE }}</div>
              <div class="col-7">{{ moment(monetaryOrder.created_at).format('DD-MM-YYYY HH:mm:ss') }}</div>
            </div>
            <div class="row mb-1">
              <div class="col-5">{{ lang.monetary_compensation.EXPIRY_DATE }}</div>
              <div class="col-7">{{ moment(monetaryOrder.expiry_date).format('DD-MM-YYYY HH:mm:ss') }}</div>
            </div>
            <div class="row mb-1">
              <div class="col-5">{{ lang.monetary_compensation.COMPENSATION_AMOUNT }}</div>
              <div class="col-7">
                {{ monetary.currency }} {{ parseInt(monetaryOrder.amount) + parseInt(monetaryOrder.open_amount) }}
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5">{{ lang.monetary_compensation.COMPENSATION_TYPE }}</div>
              <div class="col-7">
                <span v-if="monetaryOrder.compensation_type == 1">{{ lang.monetary_compensation.COMPENSATION_TYPE_1 }}</span>
                <span v-if="monetaryOrder.compensation_type == 2">{{ lang.monetary_compensation.COMPENSATION_TYPE_2 }}</span>
                <span v-if="monetaryOrder.compensation_type == 3">{{ lang.monetary_compensation.COMPENSATION_TYPE_3 }}</span>
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-5">{{ lang.monetary_compensation.COMPENSATION_OPTION }}</div>
              <div class="col-7">
                <span v-if="monetaryOrder.compensation_option == 0">{{ lang.monetary_compensation.COMPENSATION_OPTION_1 }}</span>
                <span v-if="monetaryOrder.compensation_option == 1">{{ lang.monetary_compensation.COMPENSATION_OPTION_2 }}</span>
              </div>
            </div>
            <div v-if="monetaryOrder.compensation_option == 1" class="row mb-1">
              <div class="col-5">{{ lang.monetary_compensation.CASH_PICK_UP_ORDER }} 1</div>
              <div class="col-7">{{ monetary.currency }} {{ monetaryOrder.amount }}</div>
            </div>
            <div v-if="monetaryOrder.compensation_option == 1" class="row mb-1">
              <div class="col-5">{{ lang.monetary_compensation.OPEN_AMOUNT }}</div>
              <div class="col-7">{{ monetary.currency }} {{ monetaryOrder.open_amount }}</div>
            </div>
            <div class="row pt-3 mb-2">
              <div class="col-12">
                <b>{{ lang.monetary_compensation.CASH_INFO }}</b>
              </div>
            </div>
            <div class="row">
              <div class="col-12">{{ lang.monetary_compensation.ORDER_NUMBER }}: {{ monetaryOrder.number_order }}</div>
              <div class="col-12">
                {{ lang.monetary_compensation.CASH_PICK_UP_AMOUNT }}: {{ monetary.currency }} {{ monetaryOrder.amount }}
              </div>
              <div class="col-12">{{ lang.monetary_compensation.SECURITY_CODE }}: {{ monetaryOrder.security_code }}</div>
              <div v-if="monetaryOrder.compensation_option == 1" class="col-12">
                {{ lang.monetary_compensation.EXPIRY_DATE_ORDER }}:
                {{ moment(monetaryOrder.expiry_date).format('DD-MM-YYYY HH:mm:ss') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import '@/assets/scss/modules/MonetaryCompensation.scss'
import { mapGetters } from 'vuex'
import Title from '@/components/Title/index'
import { replaceStr } from '@/utils/helper'

export default {
  name: 'CashPickUp',
  components: {
    Title
  },
  props: {
    secret: {
      type: String,
      default: ''
    },
    orderId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      Services: 'Home/Services',
      InfoPaxMonetary: 'MonetaryCompensation/InfoPaxMonetary',
      MonetaryService: 'Home/monetaryService'
    }),
    passengerName() {
      if (!_.isEmpty(this.pax)) {
        return this.pax.title + ' ' + this.pax.first_name + ' ' + this.pax.last_name
      }
      return ''
    },
    monetary() {
      return this.MonetaryService.detail_monetary
    },
    monetaryOrder() {
      if (!_.isEmpty(this.MonetaryService) && this.MonetaryService.detail_monetary) {
        let order = _.find(this.MonetaryService.detail_monetary.orders, { id: parseInt(this.orderId) })
        this.fetchStatus(order)
        return order
      }
      return {}
    }
  },
  watch: {
    pax: function (el) {
      if (el && el.id) {
        let cur_pax_id = el.curPaxID ? el.curPaxID : el.id
        this.$store.dispatch('Home/getServices', cur_pax_id)
      }
    }
  },
  methods: {
    replaceStr,
    fetchStatus(monetaryOrder) {
      if (monetaryOrder && monetaryOrder.number_order) {
        let dataSend = {
          issuer_ticket: monetaryOrder.number_order,
          airline_id: this.airline.airline_id
        }
        this.$store.dispatch('MonetaryCompensation/statusMonetary', dataSend).then((response) => {
          if (response.success) {
            if (response.data && response.data.status && response.data.status === 'BLOCKED') {
              this.$swal(this.lang.monetary_compensation.MESSAGE_STATUS_BLOCKED)
            }
            if (response.data && response.data.monetary_status) {
              this.monetaryOrder.status = response.data.monetary_status
            }
          }
        })
      }
    }
  }
}
</script>
